import './styles/global.css';
import Navbar   from './components/Navbar';
import Hero     from './components/Hero';
import Services from './components/Services';
import Process  from './components/Process';
import WhyUs    from './components/WhyUs';
import Contact  from './components/Contact';
import Footer   from './components/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Process />
      <WhyUs />
      <Contact />
      <Footer />
    </>
  );
}
